/**
 * pinStrength — shared weak-PIN blocklist.
 *
 * Must stay in sync with `_WEAK_PINS` in backend/server.py. The backend is
 * authoritative (it rejects with HTTP 400 regardless), but mirroring the
 * list client-side lets us surface a toast without a round-trip.
 */

export const WEAK_PINS = new Set([
  "123456", "111111", "000000", "222222", "333333", "444444",
  "555555", "666666", "777777", "888888", "999999",
  "098765", "654321", "123321", "123123", "121212", "112233",
]);

export const WEAK_PIN_MESSAGE =
  "Use a stronger PIN — that one is too easy to guess.";

export function isWeakPin(pin) {
  return WEAK_PINS.has((pin || "").trim());
}
